import { ChartKind } from '../../components/platinum-table-old/lib/chart-guide'

export type DataType = 'freq' | 'colPct' | 'rowPct'

export interface VisualizationSlide {
  id: string
  title: string
  description: string
  tableFile: string        // Filename in the tables folder
  tableName: string        // Display name for the table
  chartType: ChartKind     
  dataType: DataType       
  chartSettings?: {
    selectedCategories?: string[]
    selectedMonths?: string[]
    selectedHeader?: string  // For single-select charts like bar/column
    [key: string]: any
  }
}

// Configuration for 10 visualization slides based on common market research scenarios
export const visualizationSlides: VisualizationSlide[] = [
  {
    id: 'slide-1',
    title: 'Brand Awareness Overview',
    description: 'Overall brand awareness across all demographics',
    tableFile: 'brand-awareness-overall.json',
    tableName: 'Q1. Which of these brands are you aware of?',
    chartType: 'pie',
    dataType: 'freq',
    chartSettings: {}
  },
  {
    id: 'slide-2', 
    title: 'Brand Awareness by Age Group',
    description: 'Brand awareness segmented by age demographics',
    tableFile: 'brand-awareness-age.json',
    tableName: 'Q1. Brand Awareness x Age Group',
    chartType: 'clusteredColumn',
    dataType: 'colPct',
    chartSettings: {
      selectedCategories: ['Sky Sports', 'BT Sport', 'Amazon Prime'],
      selectedMonths: ['18-24', '25-34', '35-44', '45-54', '55+']
    }
  },
  {
    id: 'slide-3',
    title: 'Customer Satisfaction Trend',
    description: 'Monthly customer satisfaction scores',
    tableFile: 'satisfaction-trend.json',
    tableName: 'Monthly Customer Satisfaction',
    chartType: 'line',
    dataType: 'freq',
    chartSettings: {
      selectedCategories: ['Very Satisfied', 'Satisfied'],
      selectedMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
    }
  },
  {
    id: 'slide-4',
    title: 'Product Usage Frequency',
    description: 'How often customers use different products',
    tableFile: 'usage-frequency.json',
    tableName: 'Q5. How often do you use these services?',
    chartType: 'stackedBar',
    dataType: 'rowPct',
    chartSettings: {
      selectedCategories: ['Daily', 'Weekly', 'Monthly', 'Rarely'],
      selectedMonths: ['Sky Sports', 'Sky Cinema', 'Sky Atlantic']
    }
  },
  {
    id: 'slide-5',
    title: 'Net Promoter Score',
    description: 'Likelihood to recommend by customer segment',
    tableFile: 'nps-segments.json',
    tableName: 'Q10. How likely are you to recommend?',
    chartType: 'column',
    dataType: 'freq',
    chartSettings: {
      selectedHeader: 'Promoters'
    }
  },
  {
    id: 'slide-6',
    title: 'Competitive Comparison',
    description: 'Feature comparison across competitors',
    tableFile: 'competitive-analysis.json',
    tableName: 'Feature Comparison Matrix',
    chartType: 'clusteredBar',
    dataType: 'freq',
    chartSettings: {
      selectedCategories: ['Sky', 'BT', 'Virgin Media'],
      selectedMonths: ['Sports Coverage', 'Movie Selection', 'Price Value', 'Customer Service']
    }
  },
  {
    id: 'slide-7',
    title: 'Content Preferences',
    description: 'Most watched content categories',
    tableFile: 'content-preferences.json',
    tableName: 'Q7. Which content do you watch most?',
    chartType: 'bar',
    dataType: 'freq',
    chartSettings: {
      selectedHeader: 'Total'
    }
  },
  {
    id: 'slide-8',
    title: 'Subscription Changes',
    description: 'Changes in subscription levels over time',
    tableFile: 'subscription-changes.json',
    tableName: 'Subscription Level Changes',
    chartType: 'stackedColumn',
    dataType: 'freq',
    chartSettings: {
      selectedCategories: ['Basic', 'Standard', 'Premium'],
      selectedMonths: ['Q1', 'Q2', 'Q3', 'Q4']
    }
  },
  {
    id: 'slide-9',
    title: 'Regional Distribution',
    description: 'Customer distribution across UK regions',
    tableFile: 'regional-distribution.json',
    tableName: 'Customer Base by Region',
    chartType: 'pie',
    dataType: 'colPct',
    chartSettings: {}
  },
  {
    id: 'slide-10',
    title: 'Churn Risk Analysis',
    description: 'Customer segments by churn risk level',
    tableFile: 'churn-risk.json',
    tableName: 'Churn Risk Segmentation',
    chartType: 'scatter',
    dataType: 'freq',
    chartSettings: {
      selectedCategories: ['Low Risk', 'Medium Risk', 'High Risk'],
      selectedMonths: ['0-6 months', '6-12 months', '12+ months']
    }
  }
]

export const getSlideById = (id: string): VisualizationSlide | undefined => {
  return visualizationSlides.find(slide => slide.id === id)
}

export const getSlideByIndex = (index: number): VisualizationSlide | undefined => {
  return visualizationSlides[index]
}